import React, { useEffect, useState } from 'react';
import { AppContext } from '../../App';
import { HOURS_FILTERS } from '../../data/constants';
import { classIf } from '../../data/utils/classIf';
import { formatDate } from '../../data/utils/formatDate';
import { getDayDesc } from '../../data/utils/getDayDesc';
import { labels } from '../../data/labels';
import { useFilters } from '../FiltersContext';
import { PrematchContext } from '../Prematch';

export function processFilters(dayFilters) {
    dayFilters.forEach((d, i) => {
        if (i === 0) {
            d.desc = labels['prematch_page.temporal_filters.today'];
        } else {
            const date = formatDate(`${d.date} 00:00`);
            d.desc = `${getDayDesc(d.id)} ${date.day}.${date.month}`;
        }
        d.type = d.date;
    });
    return [
        {type: '3H', desc: labels['prematch_page.temporal_filters.3h'], hours: 3},
        ...dayFilters,
        {type: 'ALL', desc: labels['prematch_page.temporal_filters.all'], hours: null}
    ];
}

function MainMenuNavbar(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const filtersData = useFilters();
    const [filters] = useState(() => {
        return processFilters(filtersData);
    });

    function handleClick(f) {
        if (HOURS_FILTERS.includes(f.type)) {
            const dayFilter = {
                ...filters.find(f => f.date != null),
                type: f.type
            };
            prematchContext.openMultiEventsByDate(dayFilter);
        } else {
            prematchContext.setTemporalFilter(f);
        }
    }

    useEffect(() => {
        if (props.openFromPath && appContext.handleOpenFromPath) {
            if(props.openFromPath.dateFilter){
                
            }

            //handledOpenFromPath.current = true;
            if(!props.openFromPath.match){
                appContext.setHandleOpenFromPath(false);

            }


        }
    }, [props.openFromPath]);

    return (
        <nav id="nav-temporal-filter" className="nav-slider">
            <div className="nav-slider-item-container" onClick={() => window.openSection('live')}>
                <span className="nav-slider-item">Live</span>
            </div>
            {filters.map(filter => {
                const selected = prematchContext.temporalFilter.type === filter.type;
                return (
                    <div key={filter.type} className={"nav-slider-item-container" + classIf(selected, 'selected')} onClick={() => handleClick(filter)}>
                        <span className="nav-slider-item">{filter.desc}</span>
                    </div>
                );
            })}
        </nav>
    );
}

export default MainMenuNavbar;